import { render, staticRenderFns } from "./LabTimeline.vue?vue&type=template&id=63242a83&scoped=true&"
import script from "./LabTimeline.vue?vue&type=script&lang=js&"
export * from "./LabTimeline.vue?vue&type=script&lang=js&"
import style0 from "./LabTimeline.vue?vue&type=style&index=0&id=63242a83&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63242a83",
  null
  
)

export default component.exports